var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skill-page"},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":24}},[_c('CodeCard',{attrs:{"title":"坐标系转换工具","description":"支持GPS(WGS84)、高德/腾讯(GCJ02)、百度(BD09)三种坐标系相互转换，自动识别并清理坐标格式","codeContent":_vm.transformCode}},[_c('CoordTransform')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }